import ApiService from "@/core/services/ApiService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface image {
  name: string;
  path: string;
}
export interface News {
  name: string;
  slug: string;
  image: image;
  short_content: string;
  _id: string;
  id: string;
}
export interface NewsData {
  errors: Array<string>;
  news: News;
  listData: Array<News>;
  totalPages: number;
  totalDocs: number;
}
const model_name = "news";
@Module
export default class NewsModule extends VuexModule implements NewsData {
  errors = [];
  news = {} as News;
  listData = [];
  totalPages = 0;
  totalDocs = 0;

  get getTotalNews(): number {
    return this.totalDocs;
  }
  get getNewsPages(): number {
    return this.totalPages;
  }
  get getNewsErrors(): Array<string> {
    return this.errors;
  }

  get listDataNews(): Array<News> {
    return this.listData;
  }

  get currentNews(): News {
    this.news.id = this.news._id;
    return this.news;
  }

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = error;
  }

  @Mutation
  ["SET_CURRENT_NEWS"](data) {
    this.news = data;
  }

  @Mutation
  ["M_GET_NEWS_DATA"](data) {
    this.listData = data.data;
    this.totalDocs = data.totalDocs;
    this.totalPages = data.totalPages;
  }

  @Action
  ["GET_NEWS_DATA"](params) {
    return new Promise<void>((resolve, reject) => {
      ApiService.setHeader();
      ApiService.get(model_name, params)
        .then(({ data }) => {
          this.context.commit("M_GET_NEWS_DATA", data);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.message);
          reject();
        });
    });
  }

  @Action
  ["GET_NEWS_DETAIL"](id) {
    return new Promise<void>((resolve, reject) => {
      ApiService.setHeader();
      ApiService.get(model_name + "/show", id)
        .then(({ data }) => {
          this.context.commit("SET_CURRENT_NEWS", data.data);
          resolve();
          return data.data;
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.message);
          reject();
        });
    });
  }

  @Action
  ["ADD_NEWS"](credentials) {
    return new Promise<void>((resolve, reject) => {
      ApiService.setHeader();
      ApiService.post(model_name + "/create", credentials)
        .then(({ data }) => {
          this.context.commit("SET_CURRENT_NEWS", data);
          resolve(data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.message);
          reject();
        });
    });
  }

  @Action
  ["UPDATE_NEWS"](payload) {
    ApiService.setHeader();
    return new Promise<void>((resolve, reject) => {
      ApiService.put(model_name + "/update", payload)
        .then(({ data }) => {
          this.context.commit("SET_CURRENT_NEWS", data);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.message);
          reject();
        });
    });
  }

  @Action
  ["DELETE_NEWS"](payload) {
    ApiService.setHeader();
    return new Promise<void>((resolve, reject) => {
      ApiService.delete(model_name + "/delete/" + payload.id + "?force=true")
        .then(() => {
          this.context.dispatch("GET_NEWS_DATA", payload.searchString);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject();
        });
    });
  }
}
